module.exports = __webpack_public_path__ + "static/media/gmad-logo.8bd1c60a.svg";